import React, { useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LoginForm from "./components/LoginForm";
import ConsumerList from "./components/ConsumerList";
import ResetPasswordForm from "./components/ResetPasswordForm";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("Token"));
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [userName, setUserName] = useState(localStorage.getItem("User") || "Admin");

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setShowResetPassword(false);
  };

  const handleLoginSuccess = (loginName) => {
    setUserName(loginName);
    setIsLoggedIn(true);
    setShowResetPassword(false);
  };

  const handleResetPasswordSuccess = () => {
    // After successful reset password, close modal and go to login
    setShowResetPassword(false);
    setIsLoggedIn(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-100 relative">
      <div className="flex-grow p-4">
        {isLoggedIn ? (
          <>
            <Header
              onLogout={handleLogout}
              userName={userName}
              onResetPassword={() => setShowResetPassword(true)}
            />
            <ConsumerList />
          </>
        ) : (
          <>
            {/* No header on login page */}
            <LoginForm
              onLogin={handleLoginSuccess}
              onForgotPassword={() => setShowResetPassword(true)}
            />
          </>
        )}
      </div>

      <Footer />

      {/* Reset Password Modal */}
      {showResetPassword && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-4 w-full max-w-md shadow-lg relative">
            <button
              className="absolute top-2 right-3 text-gray-600 hover:text-gray-900"
              onClick={() => setShowResetPassword(false)}
              aria-label="Close reset password"
            >
              ✕
            </button>

            <ResetPasswordForm
              onBackToLogin={() => setShowResetPassword(false)}
              onSuccess={handleResetPasswordSuccess}
            />

          </div>
        </div>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default App;
